export default {
  message: {
    title:{
      HomeTitle:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
      Download:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
      AboutUs:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
      News:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
      NewsDetails:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
      Company:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
      AndroidProcess:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
      IOSProcess:"Kudi 공개 체인-이것은 혁신적인 Layer2 공개 체인입니다.",
    },
    zh:'중국어(간체)',
    en:'영어',
    kor:'한국인',
    i18:'중국어간체',
    headerMenu_home:'첫 페이지',
    headerMenu_news:'소식',
    headerMenu_download:'다운로드',
    headerMenu_aboutUs:'우리를',
    homeTitle1:`디지털 화폐를 보자\n어디서나 보이게 된다`,
    homeTitle2:'DAO를 사용하여 지갑을 관리하고 보안을 강화하세요.KuDee 퍼블릭 체인의 가장 큰 분산형 지갑입니다.',
    Android:'Android',
    Ios:'Apple IOS',
    AndroidGeneral:'Android(일반적인)',
    Version:'버전 번호',
    UpdateTime:'업데이트 시간',
    IOSSuper:'Apple IOS',
    homeTitle3:'우리는 당신에게 디지털 자산을 제공합니다호위',
    homeTitle4:'귀하의 디지털 자산은 블록체인 네트워크에 저장되며, 각 자산은 블록체인 기술로 보호됩니다',
    homeTitle5:'보안 액세스',
    homeTitle6:'자산을 체인에 올려 익명의 자산관리가 가능하며 자산의 안전성이 보장됩니다',
    homeTitle7:'간단한 거래',
    homeTitle8:'언제 어디서나 귀하의 디지털 자산을 쉽게 거래하세요. 이체, 크로스체인 등 다양한 거래가 가능합니다',
    homeTitle9:'멀티체인 관리',
    homeTitle10:'KuDee, BSC, Polygon, TRON 및 기타 블록체인 네트워크를 지원하는 온체인 토큰에 쉽게 액세스하세요',
    homeTitle11:'최신 뉴스 및 정보',
    homeTitle12:'저희는 전 세계적으로 블록체인 사업과 제품을 홍보하고 있으며, 여기에서 최신 뉴스와 상담을 실시간으로 게시합니다',
    homeTitle13:'디지털 화폐를 보자\n어디서나 보이게 된다',
    homeTitle14:'*중요 성명: 현재 KuDee Wallet은 미국 관할권과 감독을 받으며 관련 규제 기관으로부터 허가를 받았습니다.',
    homeTitle15:'소셜 미디어',
    homeTitle16:'KUDEE WALLET 다운로드 주소',
    homeTitle17:'KuDee Wallet은 여러 체인을 지원하는 셀프호스팅 지갑입니다. 사용하기 간편하고 안전하며 전 세계 수천만 명의 사람들이 신뢰하고 사랑합니다.',
    homeTitle18:'* 반드시 공식 홈페이지에서 지갑 앱을 다운로드 하시고, 해당 홈페이지의 SSL 인증서를 확인해주시기 바랍니다.',
    homeTitle19:'* 다른 사람이 귀하의 계정 및 비밀번호를 빌리도록 신뢰하지 마십시오.',
    homeTitle20:'*사용자 자산은 모두 온체인에 있으므로 관련 인증서 정보를 적절히 보관하세요.',
    homeTitle21:'* 개인키와 니모닉 문구를 보호하고, 공개하지 말고, 누구와도 공유하지 마세요.',
    homeTitle22:'*안전에 대한 지식을 더 알아보세요',
    homeTitle23:'최신 버전',
    homeTitle24:'지갑 앱의 진위성을 확인하는 방법？',
    AboutUsTitle1:'우리에 대하여',
    AboutUsTitle2:'여기서 우리를 빠르게 찾을 수 있습니다',
    AboutUsTitle3:'회사 정보',
    AboutUsTitle4:'당사는 많은 국가와 지역에 등록되어 있으며, 항상 합법적으로 운영하고 규정을 준수하는 데 최선을 다하고 있습니다',
    AboutUsTitle5:'1.호주 본사: 글로벌 전략 운영 센터',
    AboutUsTitle6:'2.미국 지사: 토큰 운영 및 규정 준수 관리',
    AboutUsTitle7:'3.영국 지사: 글로벌 기술 지원 및 R&D 지원',
    AboutUsTitle8:'4.캐나다 기업 : 글로벌 노드 운영 및 유지관리 센터',
    AboutUsTitle9:'*회사 정보를 자세히 보려면 여기를 클릭하세요',
    AboutUsTitle10:'다음 방법을 통해 당사에 연락하여 사업 협력을 모색하실 수 있습니다',
    AboutUsTitle11:'공식 미디어',
    homeTitle25:'Google Authenticator 받기',
    News1title:'KuDee 퍼블릭 체인 공식 출시, 퍼블릭 체인 분야 진출',
    News1time:'2024년 2월',
    News1Introduction:'회사의 핵심 개발 멤버는 Google, Microsoft, Binance와 같은 인터넷 기업 출신으로 풍부한 개발 경험을 가지고 있습니다',
    News2title:"KuDee 퍼블릭 체인 팀, 퍼블릭 체인 생태 시리즈 제품 출시",
    News2time:'2024년 12월',
    News2Introduction:'KuEX 앱과 KuDee 퍼블릭 체인 브라우저 등 핵심 생태 제품을 출시했습니다',
    News3title:'KuEX APP가 공식 출시되어 다양한 새로운 기능이 통합되었습니다',
    News3time:'2025년 1월-3월',
    News3Introduction:'KuEX 앱에는 지갑, DAPP, 거래소, 소셜 및 엔터테인먼트 기능이 포함되어 있습니다',

    Process1:'퍼블릭 체인을 이용해 무수한 기적을 창조하다！',
    Process2:'Android다운로드',
    Process3:'Iphone다운로드',
    Process4:'튜토리얼을 보려면 아래로 스크롤하세요',
    Process5:'작업 프로세스',
    Process6:'다운로드 버튼을 클릭하세요',
    Process7:'"다운로드 및 설치"를 클릭하세요',
    Process8:'"설치"를 클릭하세요',
    Process9:'"지금 신뢰"를 클릭하세요',
    Process10:'"허용"을 클릭하세요',
    Process11:'"이 앱을 신뢰합니다"를 클릭하세요',
    Process12:'"MOST INC EOOD 신뢰"를 클릭하세요',
    Process13:'이 앱을 신뢰하세요를 클릭하세요',
    Process14:'블록체인 기술을 활용해 더 나은 금융 세계를 만들다',
  }
}
